<template lang="pug">
v-card(width='480' class='delete-user-agent-dialog')
  div.pt-10.pb-6
    v-card-title.d-flex.align-center.flex-column.justify-center.pa-0
      v-icon(size='70' color='orange') icon-chat

    v-card-text.pt-4.px-10.text-center
      span.delete-message(style='font-family:"Segoe UI"; font-size:16px; color:#444;')
        | {{ $t('PORTAL.DELETE_ROWS_CONFIRM_MESSAGE', { count, tableName }) }}

  v-card-actions.px-6.py-4.justify-end(style='background-color:#F8F9FA; border-top:1px solid #E8E8E8;')
    v-btn.mr-2(
      @click='onCancel'
      width='100px'
      height='40'
      outlined
      color='#666666'
      style='border:1px solid #888888; border-radius:4px; background-color:white;'
      :ripple='false'
    )
      span(style="font-family:'Segoe UI'; font-weight:600; font-size:16px; letter-spacing:0.5px; color:#666666;") {{ $t('PORTAL.DONT_DELETE') }}

    v-btn(
      @click='onConfirm'
      width='120px'
      height='40'
      color='#E6494E'
      style='border-radius:4px;'
      :ripple='false'
      depressed
    )
      span(style="font-family:'Segoe UI'; font-weight:600; font-size:16px; letter-spacing:0.5px; color:#FFFFFF;") {{ $t('PORTAL.CONFIRM_DELETE') }}
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "deleteRowsDialog",
  props: {
    count: { 
      type: Number, 
      required: true 
    },
    tableName: { 
      type: String, 
      required: true 
    },
  },
  methods: {
    onCancel() { 
      this.$emit("cancel"); 
    },
    onConfirm() { 
      this.$emit("confirm"); 
    },
  },
});
</script>

<style scoped lang="css">
.delete-user-agent-dialog {
  border-radius: 8px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
}
.delete-message {
  line-height: 1.6;
}
</style>